import { gql } from '@apollo/client';

const query = gql`
  query searchSuggestSitemapSuburbs($params: JSONObject) {
    searchSuggestSitemapSuburbs(params: $params)
  }
`;

module.exports = query;
